import { useQuery } from 'react-query'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { fetchUserProfileById } from '@dc-shared-web/hooks/api/user/fetchUserProfileById'

type UseGetUserProfileByIdParams = {
  userId: string | null
}

export const useGetUserProfileById = ({
  userId,
}: UseGetUserProfileByIdParams) => {
  const svcCrunchesApiClient = useSvcCrunchesContext()

  return useQuery(
    `user-${userId}`,
    () => {
      /* This will never happen because of the enabled below but from the TS perspective it's possible. */
      if (!userId) {
        throw new Error('useGetUserProfileById: missing userId')
      }

      return fetchUserProfileById(svcCrunchesApiClient, {
        userId,
      })
    },
    {
      enabled: !!userId,
    }
  )
}
